import Firebase from './index'

import Resizer from 'react-image-file-resizer';
import { MessageApiUrl } from '../config/api'
import { authorizedFetch } from '../config/auth_axios'

export default class AvatarStore {
    static cache: { [index: number]: string } = {}
    static cachePromise: { [index: number]: Promise<string> } = {}
    private static genPath(cid: number, uid: number) {
        return `/company/${cid}/avatar/${uid}.jpg`
    }
    public static getUrl(cid:number, uid:number):Promise<string> {
        if (AvatarStore.cache[uid]) {
            return Promise.resolve(AvatarStore.cache[uid])
        }
        if (uid in AvatarStore.cachePromise) {
            return AvatarStore.cachePromise[uid]
        }

        // Do not issue a public URL (getDownloadURL). Fetch the bytes from the
        // authentication-required proxy (homis_messages) and convert them into a
        // blob: object URL. Cannot be fetched when unauthenticated.
        // cid is not sent because the server resolves it from the logged-in user
        // (only the user's own company is viewable).
        const url = MessageApiUrl(`avatar?uid=${encodeURIComponent(String(uid))}`)
        return AvatarStore.cachePromise[uid] = authorizedFetch.get(url, { responseType: "blob" }).then((res: any) => {
            const objectUrl: string = (window.URL || (window as any).webkitURL).createObjectURL(res.data)
            AvatarStore.cache[uid] = objectUrl
            return objectUrl
        }).catch(() => {
            AvatarStore.cache[uid] = "none"
            return "none"
        })
    }

    public static put(cid: number, uid: number, file: File) {
        return new Promise((resolve, reject) => {
            Resizer.imageFileResizer(
                file,
                400, 400,
                'JPEG',
                100, 0,
                async uri => {
                    const storageRef = Firebase.instance.storage.ref()
                    delete AvatarStore.cache[uid]
                    delete AvatarStore.cachePromise[uid]
                    resolve(await storageRef.child(this.genPath(cid, uid)).putString(uri.substring(23), 'base64'))
                },
                'base64'
            );
        })
    }
}
